<div class="downlaod-agent-flyout">
  <div class="container">
    <div class="close-icon">
      <div class="main_title">
        <i class="icon mdi mdi-download-circle"></i>
        <span><b>Download agents</b></span>
      </div>
      <i class="mdi mdi-close" (click)="close()"></i>
    </div>
    <mat-card class="download_container">
      <div class="downlaod-option">
        <div class="other-download">
          <div class="other-opt-download border_bottom">
            <div>
              <div class="download-header download-header-with-icon">
                <div class="icon-with-title">
                  <i class="agent-type-icon mdi mdi-microsoft-windows"></i>
                  <div class="agent-name">
                    <span class="agent-type-label">Microsoft Windows Agent</span>
                  </div>
                </div>
                <div class="agent-info">
                  <div class="agent-link-type">
                    <ng-container *ngTemplateOutlet="agentInfo; context: { linkURL: 'windows' }">
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="other-opt-download border_bottom">
            <div>
              <div class="download-header download-header-with-icon">
                <div class="icon-with-title">
                  <i class="agent-type-icon mdi mdi-raspberry-pi"></i>
                  <div class="agent-name">
                    <span class="agent-type-label">Raspberry Pi Agent</span>
                  </div>
                </div>
                <div class="agent-info">
                  <div class="agent-link-type">
                    <ng-container *ngTemplateOutlet="agentInfo; context: { linkURL: 'olhw' }">
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="virtual-agent-section">
          <div class="other-opt-download">
            <div>
              <div class="download-header">
                <i class="agent-type-icon mdi mdi-server"></i>
                <div class="agent-name">
                  <span class="agent-type-label">Virtual Agents</span>
                  <span class="agent-type-sublabel">
                    - You need an image and a configuration method, in any combination</span
                  >
                </div>
              </div>
              <div class="block-margin sub-virtual">
                <div class="group-label">Choose an image</div>
                <div class="group-item">
                  <div class="virtual-type">
                    <div class="label">
                      <span class="main-label">QCOW2</span>
                      <span class="sub-label">QEMU/KVM format</span>
                    </div>
                    <div class="virtual-type-link">
                      <ng-container *ngTemplateOutlet="agentInfo; context: { linkURL: 'qcow2' }">
                      </ng-container>
                    </div>
                  </div>
                  <div class="virtual-type">
                    <div class="label">
                      <span class="main-label">OVA</span>
                      <span class="sub-label">vSphere/ESXi</span>
                    </div>
                    <div class="virtual-type-link">
                      <ng-container *ngTemplateOutlet="agentInfo; context: { linkURL: 'ova' }">
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="group-label">Choose a configuration method</div>
                <div class="group-item">
                  <div class="virtual-type">
                    <div class="label">
                      <span class="main-label">Configuration ISO</span>
                      <span class="sub-label">Environments that can mount a disk</span>
                    </div>
                    <div class="virtual-type-link">
                      <ng-container
                        *ngTemplateOutlet="agentInfo; context: { linkURL: 'agent-image' }"
                      >
                      </ng-container>
                    </div>
                  </div>
                  <div class="virtual-type">
                    <div class="label">
                      <span class="main-label">Configuration file</span>
                      <span class="sub-label">Environments that can load a file</span>
                    </div>
                    <div class="virtual-type-link">
                      <ng-container
                        *ngTemplateOutlet="agentInfo; context: { linkURL: 'cloud_init' }"
                      >
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>

<ng-template #agentInfo let-linkURL="linkURL">
  <div>
    <a
      class="link"
      matTooltip="{{
        downloadURL[linkURL] && downloadURL[linkURL].length > 0
          ? 'Download'
          : 'Download link is not available'
      }}"
      [ngClass]="{
        disabled:
          !downloadURL[linkURL] || (downloadURL[linkURL] && downloadURL[linkURL].length === 0)
      }"
      [attr.href]="downloadURL[linkURL]"
      download
      ><i class="icon icon-color mdi mdi-download"></i>
      <div class="link-label"><span>Download</span></div></a
    >
  </div>
  <div>
    <a
      class="link copy-icon"
      matTooltip="{{
        downloadURL[linkURL] && downloadURL[linkURL].length > 0
          ? 'Copy to clipboard'
          : 'Link is not available to copy'
      }}"
      (click)="copyLink(downloadURL[linkURL])"
      [cdkCopyToClipboard]="downloadURL[linkURL]"
      [ngClass]="{
        disabled:
          !downloadURL[linkURL] || (downloadURL[linkURL] && downloadURL[linkURL].length === 0)
      }"
    >
      <i class="icon icon-color mdi mdi-content-copy"></i>
      <div class="link-label">
        <span>Copy</span>
      </div></a
    >
  </div>
</ng-template>
